import { environment } from '../config/environment';

const DEFAULT_RECIPIENT = 'support@opencare.no';
const ACCESS_REQUEST_SUBJECT = 'Forespørsel om tilgang til OpenCare';

function getAccessRequestRecipient() {
  const configured = (environment.accessRequestUrl || '').trim();
  if (!configured) {
    return DEFAULT_RECIPIENT;
  }

  if (configured.startsWith('mailto:')) {
    const address = configured.slice('mailto:'.length).split('?')[0].trim();
    return address || DEFAULT_RECIPIENT;
  }

  if (configured.includes('@')) {
    return configured;
  }

  return DEFAULT_RECIPIENT;
}

function buildAccessRequestBody({ customerName, requesterName, requesterEmail }) {
  const lines = [
    'Hei,',
    '',
    'Jeg ønsker tilgang til OpenCare. Vennligst fyll ut / bekreft informasjonen under:',
    '',
    `Kommune: ${customerName || ''}`,
    `Navn: ${requesterName || ''}`,
    `E-post: ${requesterEmail || ''}`,
    'Godkjenner av tilgang (navn og e-post): ',
    '',
    'Med vennlig hilsen',
    requesterName || ''
  ];

  return lines.join('\r\n');
}

export function buildAccessRequestMailto({
  customerName = '',
  requesterName = '',
  requesterEmail = ''
} = {}) {
  const subject = encodeURIComponent(ACCESS_REQUEST_SUBJECT);
  const body = encodeURIComponent(
    buildAccessRequestBody({ customerName, requesterName, requesterEmail })
  );

  return `mailto:${getAccessRequestRecipient()}?subject=${subject}&body=${body}`;
}

export function openAccessRequestMail(options) {
  window.location.href = buildAccessRequestMailto(options);
}
